import React, { useCallback } from 'react';
import styled from 'styled-components';

const DailyCalendarCell = styled.div`
  text-align: center;
`;

export const GanttTimeline = ({ timelineIndex, events }) => {
  const getPositionStyle = useCallback(
    (startDay, endDay) => ({
      gridRow: timelineIndex + 1,
      gridColumn: `${startDay} / ${endDay + 1}`,
    }),
    [timelineIndex]
  );

  if (!events.length) {
    return <DailyCalendarCell style={getPositionStyle(1, 1)} />;
  }
  return events.map(
    ({ startDay, endDay, contents, style, id, additionalProps }) => (
      <DailyCalendarCell
        key={id}
        style={{ ...style, ...getPositionStyle(startDay, endDay) }}
        {...additionalProps}
      >
        {contents}
      </DailyCalendarCell>
    )
  );
};
